import { extendTailwindMerge } from "tailwind-merge"
export { twJoin } from "tailwind-merge"

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      borderWidth: [
        /^border-(t|r|b|l)-\d+p$/,
        /^border-\d+p$/,
      ],
    },
  },
})
